import React, { useEffect, useState } from "react"
import Icon from "src/shared/icons"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./CarEntrance.css"
import ExtraTimeWrapper from "../../shared/ExtraTimeWrapper/ExtraTimeWrapper"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { useDate } from "src/shared/hooks/useDate"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import useMinuteTimer from "src/shared/hooks/useMinuteTimer"
import getOccupiedStatus from "../../../../helpers/getOccuppiedStatus"
import { MainTimerValue, rsTimerValue } from "../../../../helpers/getOccuppiedStatus.type"
import getFirstConceptoPendiente from "../../../../helpers/getFirstConceptoPendiente"

const CarEntrance = ({
    roomNumber,
    roomTypeName,
    occupiedExtraHours = 0,
    occupiedTimeEndCondensada = "",
    roomServiceTimeEnd = "",
    lastRentStatus,
    hasIncidences,
    occupiedTimeEnd = "",
    placas,
    peopleNum,
    easyrewards,
    ultimaOrden,
    fecha_antigua_por_entregar,
    room,
}: RoomStatusProps) => {
    const [now] = useTimePulse()
    const { UTCStringToLocalDate } = useDate()
    const { older } = getFirstConceptoPendiente(room?.ultima_renta?.ultimos_conceptos_pendientes)

    const status = getOccupiedStatus({
        now,
        occupiedTimeEndCondensada,
        ultimaOrden,
        ultimos_conceptos_pendientes: room?.ultima_renta?.ultimos_conceptos_pendientes,
        occupiedTimeEnd,
        roomNumber,
        olderConceptoPendiente: older,
        fecha_antigua_por_entregar,
    })

    const [occuppiedElapsedTime] = useElapsedTime(
        UTCStringToLocalDate(occupiedTimeEndCondensada),
        "noche",
        room?.ultima?.renta?.estado === "pendiente_pago"
    )

    const [timePagoPendiente] = useElapsedTime(
        older?.date ? older.date : UTCStringToLocalDate(occupiedTimeEndCondensada),
        "noche",
        room?.ultima?.renta?.estado !== "pendiente_pago"
    )

    const { timeValue: orderTimer } = useMinuteTimer({
        timeStartUTC: fecha_antigua_por_entregar
            ? fecha_antigua_por_entregar
            : ultimaOrden?.orden?.fecha_registro || "",
    })

    const [isNowUsingExtraTime, setisNowUsingExtraTime] = useState(false)
    useEffect(() => {
        if (UTCStringToLocalDate(occupiedTimeEnd) < now && occupiedExtraHours > 0) {
            return setisNowUsingExtraTime(true)
        }
        if (now < UTCStringToLocalDate(occupiedTimeEnd)) {
            setisNowUsingExtraTime(false)
        }
        setisNowUsingExtraTime(false)
    }, [now])

    return (
        <Wrapper
            alertBgColor1={status?.alert ? "var(--ocupada-card-1)" : null}
            alertBgColor2={status?.alert ? "var(--pink-ocupado-light)" : null}
            hasIncidences={hasIncidences}
            bgColor="var(--pink-ocupado-light)"
        >
            <RoomCardHeader
                iconName={status?.icon || "BedFilled"}
                orderTimer={(status?.rsTimer !== rsTimerValue.NA && orderTimer) || ""}
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                roomTypeName={roomTypeName}
                iconBgColor="var(--pink-ocupado)"
                iconBgSecondaryColor="var(--pink-ocupado)"
                easyrewards={easyrewards}
                roomService={!!ultimaOrden}
                timeout={status?.rsTimer === rsTimerValue.ASCExcedido}
                description={(status?.rsTimer !== rsTimerValue.NA && orderTimer) || ""}
            />
            {isNowUsingExtraTime && status?.alert ? (
                <ExtraTimeWrapper
                    extraTime={occupiedExtraHours}
                    elsapedTime={occuppiedElapsedTime}
                    entry={placas || ""}
                    entryIcon="car"
                />
            ) : (
                <div className="room-card--lg--car-entrance__body">
                    <div className="room-card--lg--car-entrance__descripcion-wrapper">
                        <div className="room-card--lg--car-entrance__descripcion">
                            <Icon name={"UserParentFill"} width={12} height={12} color={"var(--tipografa)"} />
                            <span className="room-card--lg--car-entrance__descripcion-text room-card--lg--car-entrance__descripcion-people">
                                {peopleNum}
                            </span>
                        </div>
                        <div className="room-card--lg--car-entrance__descripcion">
                            <Icon name={"car"} width={12} height={12} color={"var(--tipografa)"} />
                            <span className="room-card--lg--car-entrance__descripcion-text">{placas}</span>
                        </div>
                    </div>
                    {status?.mainTimer === MainTimerValue.rentaASC ? (
                        <span className="room-card--lg--occupied__timer--timeout">+{occuppiedElapsedTime}</span>
                    ) : (
                        <span className="room-card--lg--occupied__timer">
                            {status?.mainTimer === MainTimerValue.payASC ? timePagoPendiente : occuppiedElapsedTime}
                        </span>
                    )}
                </div>
            )}
        </Wrapper>
    )
}

export default CarEntrance
